/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Penalty for not completing the order on time. Presented as a function - increases every period of minutes by `value` starting from `start_time`. Effects on all available time windows for order fulfillment. 
 */
export interface CostPenaltyDelivery { 
    /**
     * Time in the [RFC 3339, section 5.6 (ISO8601)](https://tools.ietf.org/html/rfc3339#section-5.6) format, since the penalty takes effect.
     */
    start_time: string;
    /**
     * The period in minutes after which the penalty amount increases by `value`.
     */
    period: number;
    /**
     * The cost by which the penalty is increased each `period`.
     */
    value: number;
    /**
     * The maximum possible penalty value.
     */
    max_value: number;
}

